module.exports = __webpack_public_path__ + "img/hexagon-xmark.dbef725d.svg";